export const LocalStorageKeyConstant = {
    AUTH_KEY: 'gs-auth'
}